export const SEND_MONEY_MINIMUM_AMOUNT = 10;
